/**
 * F43-FC §6.4 — extracted from `trainer-verifications/[userId].tsx` (was the
 * inline `ConfirmDialog`). Shared by the dedicated trainer-verifications page
 * AND the platform-user Trainer panel. Props byte-identical to the original.
 *
 * Used for the no-reason confirmations: approve profile · reinstate.
 */
import { useI18n } from '@bravemove/i18n/react';
import { Banner, Dialog } from '@bravemove/ui-web';

export function TrainerConfirmDialog({
  open,
  title,
  body,
  confirmLabel,
  loading,
  error,
  destructive,
  onClose,
  onConfirm,
}: {
  readonly open: boolean;
  readonly title: string;
  readonly body: string;
  readonly confirmLabel: string;
  readonly loading: boolean;
  readonly error: string | null;
  readonly destructive?: boolean;
  readonly onClose: () => void;
  readonly onConfirm: () => void;
}) {
  const { t } = useI18n();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title={title}
      destructive={destructive ?? false}
      loading={loading}
      confirmLabel={confirmLabel}
      cancelLabel={t('admin:common.cancel')}
    >
      <p className="text-[13px] text-ink-2 leading-snug">{body}</p>
      {error ? (
        <Banner tone="danger" className="mt-3">
          {error}
        </Banner>
      ) : null}
    </Dialog>
  );
}

export default TrainerConfirmDialog;
